import * as _ from 'lodash';
import {
  FETCH_DELIVERYS_REQUESTED,
  FETCH_DELIVERYS_SUCCEEDED,
  SORT_DELIVERYS_SUCCEEDED,
  SELECT_ALL_VISIBLE_DELIVERY,
  DELIVER_PRODUCT_SUCCEEDED,
  REINDEX_SELECTED_ITEM,
  SELECT_ALL_DELIVERY,
  DELIVER_PRODUCT_FAILED,
  RESET_DELIVERY_SELECTION
} from './list.actions';

export const list = (state = { fetched: false, items: [], pagination: {}, checked: false, checkedItems: [], allChecked: false }, action) => {
  switch (action.type) {
    case FETCH_DELIVERYS_REQUESTED:
      let checkedItems = [...state.checkedItems];
      if (action.data.untouched) {
        checkedItems = [];
      } else {
        state.items.forEach(s => {
          checkedItems = checkedItems.filter(item => item.id !== s.id);
          checkedItems.push(s);
        });
      }
      return _.assign({}, state, {
        fetched: false,
        items: [...state.items],
        pagination: {...state.pagination},
        checked: state.checked,
        checkedItems: checkedItems,
        allChecked: false
      });
    case REINDEX_SELECTED_ITEM:
      checkedItems = [...state.checkedItems];
      state.items.forEach(s => {
        checkedItems = checkedItems.filter(item => item.id !== s.id);
        checkedItems.push(s);
      });
      return _.assign({}, state, {
        checkedItems: checkedItems
      });
    case RESET_DELIVERY_SELECTION:
    case DELIVER_PRODUCT_SUCCEEDED:
    case DELIVER_PRODUCT_FAILED:
      return _.assign({}, state, {
        checkedItems: [],
        items: state.items.map(s => {
          s.checked = false;
          return s;
        })
      });
    case FETCH_DELIVERYS_SUCCEEDED:
      let newCheckedItems = [...state.checkedItems];
      let newItems = action.data.map(s => {
        let originalState = state['checkedItems'].find(item => item.id === s.id );
        if (originalState) {
          s.checked = originalState.checked;
        } else {
          if (action.untouched) {
            if (!(_.isNil(action.defaultSelection) || _.isUndefined(action.defaultSelection))) {
              s.checked = action.defaultSelection;
            }
          }
          newCheckedItems.push(s);
        }
        return s;
      });
      return _.assign({}, state, {
        fetched: true,
        items: [
          ...newItems
        ],
        checked: newItems.filter(s => s.checked).length === newItems.length,
        pagination: action.pagination,
        checkedItems: newCheckedItems,
        allChecked: false
      });

    case SORT_DELIVERYS_SUCCEEDED:
      return _.assign({}, state, { fetched: true, items: action.data, total: action.total, checked: state.checked });

    case SELECT_ALL_VISIBLE_DELIVERY:
      if (state['fetched'] === true) {
        let newStateItems = state['items'].map(s => {
          s.checked = action.data;
          return s;
        });
        let modifiedCheckedItems = [...state.checkedItems];
        newStateItems.forEach(s => {
          modifiedCheckedItems = modifiedCheckedItems.filter(item => item.id !== s.id);
          modifiedCheckedItems.push(s);
        });
        return _.assign({}, state, {
          fetched: true,
          items: [
            ...newStateItems
          ],
          total: state['total'],
          checked: action.data,
          checkedItems: modifiedCheckedItems,
          allChecked: false});
      } else {
        return state;
      }
    case SELECT_ALL_DELIVERY:
      if (state['fetched'] === true) {
        return _.assign({}, state, { allChecked: true });
      } else {
        return state;
      }
    default:
      return state;
  }
};
